import DateFormatResolver from 'resolvers/date-format.resolver';

export default (data = [], granularity) => {
	const dateFormat = granularity === 'hour' ? 'hA' : 'DD MMM `YY';
	const spoofedCallsNotAnsweredSuccessRates = [];
	const labels = [];

	for (let i = 0; i < data.length; i += 1) {
		spoofedCallsNotAnsweredSuccessRates.push(data[i].spoofedCallsNotAnsweredSuccessRate);
		labels.push(DateFormatResolver.resolve(data[i].timeSlot, dateFormat));
	}

	const pointRadius = data.length > 50 ? 0 : 3;
	const borderWidth = data.length > 50 ? 1 : 3;

	return {
		data: {
			labels,
			datasets: [
				{
					backgroundColor: '#00bcd4',
					data: spoofedCallsNotAnsweredSuccessRates,
					label: 'Rate',
					fill: false,
					borderColor: '#00bcd4',
					lineTension: false,
					pointRadius,
					borderWidth,
				},
			],
		},
		options: {
			plugins: {
				datalabels: {
					display: false,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						barPercentage: 0.2,
						scaleShowGridLines: true,
						ticks: {
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						ticks: {
							stepSize: 1,
							min: 0,
							beginAtZero: true,
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: true,
							drawBorder: false,
							borderDash: [2, 2],
							color: 'rgba(0, 0, 0, 0.2)',
						},
					},
				],
			},
		},
		type: 'line',
		hasData: labels.length > 0,
	};
};
